<template>
    <div class="message ai-message files-message">
        <div class="dot"></div>
        <div class="files-message__body">
            <div v-if="isLoading" class="files-message__state">
                <span>Загрузка файлов...</span>
            </div>

            <div v-else-if="hasError" class="files-message__state files-message__state--error">
                <span>{{ msg.content.message || 'Ошибка поиска файлов' }}</span>
            </div>

            <div v-else-if="!isLoading && files.length === 0" class="files-message__state">
                <span>Файлы не найдены</span>
            </div>

            <template v-else>
                <div class="files-message__list">
                    <file-list-item v-for="file in files" :key="file.id" :file="file" :show-user="true" />
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, defineProps } from 'vue';
import { useFileStore } from '@/store/FileStore';
import { useCompanyStore } from '@/store/CompanyStore';
import FileListItem from '@/components/files/FileListItem.vue';

const props = defineProps({
    msg: { type: Object, required: true },
});

const fileStore = useFileStore();
const companyStore = useCompanyStore();

const files = ref([]);
const isLoading = ref(false);

// Стриминг: content.data = ['uuid', ...]
// История (assistant action): content.params.fileIds = ['uuid', ...]
const fileIds = computed(() => {
    const c = props.msg.content;
    if (Array.isArray(c?.data)) return c.data;
    if (Array.isArray(c?.params?.fileIds)) return c.params.fileIds;
    return [];
});

// Ошибка только если success явно false (поле есть у tool-результата стриминга)
const hasError = computed(() => props.msg.content?.success === false);

onMounted(async () => {
    if (hasError.value || fileIds.value.length === 0) return;

    const companyId = companyStore.selectedCompanyId;
    if (!companyId) return;

    isLoading.value = true;
    try {
        const result = await fileStore.fetchFilesByIds(companyId, fileIds.value);
        files.value = (result || []).map(f => ({ ...f, isViewerOpen: false }));
    } catch {
        // silent
    } finally {
        isLoading.value = false;
    }
});
</script>

<style lang="scss" scoped>
.files-message {
    &__body {
        flex: 1;
        min-width: 0;
    }

    &__state {
        font-size: 13px;
        color: var(--color-text-dark);
        padding: 4px 0;

        &--error {
            color: var(--color-red, #ef4444);
        }
    }

    &__list {
        display: flex;
        flex-direction: column;
    }
}

.ai-message {
    display: flex;
    gap: 10px;
    padding-left: 0;
    align-self: flex-start;

    .dot {
        min-width: 8px;
        min-height: 8px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: var(--color-blue);
        margin-top: 6px;
        margin-right: 5px;
        margin-left: 5px;
        flex-shrink: 0;
    }

    &.files-message {
        width: 100%;
        max-width: 100%;
    }
}
</style>
